import { BuildingAccountsReceivableDto } from '@client/api';
import i18n from 'i18next';

export const transformToExcelFormat = (
  data: BuildingAccountsReceivableDto[],
  selectedRows: Set<string>,
  selectedYear: string,
  comparisonYear: string,
) => {
  const rows: Record<string, any>[] = [];
  if (data.length === 0) return [{ [i18n.t('noData', { ns: 'reporting' })]: null }];
  data.forEach((item) => {
    if (selectedRows.has(item.buildingId) || selectedRows.size === 0) {
      rows.push({
        [i18n.t('invoices.building', { ns: 'reporting' })]: item.buildingName,
        [i18n.t('invoices.tenants', { ns: 'reporting' })]: item.tenantCount,
        [i18n.t('invoices.outstandingSelectedPeriod', { period: selectedYear, ns: 'reporting' })]:
          item.currentPeriodOutstanding.value,
        [i18n.t('invoices.outstandingComparisonPeriod', { period: comparisonYear, ns: 'reporting' })]:
          item.comparisonPeriodOutstanding.value,
        [i18n.t('invoices.invoices', { ns: 'reporting' })]: item.currentPeriodInvoiceCount,
        [i18n.t('invoices.invoicesDes', { ns: 'reporting' })]: null,
        [i18n.t('invoices.dueDate', { ns: 'reporting' })]: null,
      });
      item.tenantReceivables.forEach((tenant) => {
        rows.push({
          [i18n.t('invoices.building', { ns: 'reporting' })]: null,
          [i18n.t('invoices.tenants', { ns: 'reporting' })]: tenant.tenantName,
          [i18n.t('invoices.outstandingSelectedPeriod', { period: selectedYear, ns: 'reporting' })]:
            item.currentPeriodOutstanding.value,
          [i18n.t('invoices.outstandingComparisonPeriod', { period: comparisonYear, ns: 'reporting' })]:
            item.comparisonPeriodOutstanding.value,
          [i18n.t('invoices.invoices', { ns: 'reporting' })]: item.currentPeriodInvoiceCount,
          [i18n.t('invoices.invoicesDes', { ns: 'reporting' })]: null,
          [i18n.t('invoices.dueDate', { ns: 'reporting' })]: null,
        });
        tenant.invoices.forEach((invoice) => {
          rows.push({
            [i18n.t('invoices.building', { ns: 'reporting' })]: null,
            [i18n.t('invoices.tenants', { ns: 'reporting' })]: null,
            [i18n.t('invoices.outstandingSelectedPeriod', { period: selectedYear, ns: 'reporting' })]:
              invoice.amountOutstanding.value,
            [i18n.t('invoices.outstandingComparisonPeriod', { period: comparisonYear, ns: 'reporting' })]: null,
            [i18n.t('invoices.invoices', { ns: 'reporting' })]: invoice.invoiceNumber,
            [i18n.t('invoices.invoicesDes', { ns: 'reporting' })]: invoice.invoiceText,
            [i18n.t('invoices.dueDate', { ns: 'reporting' })]: invoice.dueDate,
          });
        });
      });
    }
  });
  return rows;
};
